import apiClient from './apiClient';

// Payment status filter options (matches backend models.PaymentStatusFilter)
export type PaymentStatusFilter = 1 | 2 | 3;
// 1 = 有預計收款 (FG03_54 IN (1,2,3,6,7,8,9,11))
// 2 = 無預計收款 (FG03_54 IN (4,5,10))
// 3 = 全部

export interface QueryParams {
  custFrom?: string;
  custTo?: string;
  invFrom?: string;
  invTo?: string;
  dateFrom?: string;
  dateTo?: string;
  expectedDateFrom?: string;
  paymentStatus?: PaymentStatusFilter;
  includeZeroBalance?: boolean;
  saleFrom?: string;
  saleTo?: string;
  deptFrom?: string;
  deptTo?: string;
}

export interface ARRow {
  cust_code: string;     // FG03_01: 客戶代號
  inv_no: string;        // FG03_02: 交運單號
  delivery_date: string; // FG03_22: 交運日期
  currency: string;      // FG03_16: 幣別
  doc_type: string;      // FG03_21: 單據類型(G/S/I)
  exchange_rate: number; // FG03_17: 匯率
  inv_amt: number;       // FG03_11: 應收金額
  paid_amt: number;      // FG03_12 calculated: 已收金額
  balance: number;       // FG03_11 - paid_amt: 餘額
  sale_no: string;       // 業務員代號
  sale_name: string;     // 業務員名稱
  dept_no: string;       // 部門代號
  dept_name: string;     // 部門名稱
  cust_name: string;     // 客戶名稱
}

export interface QueryResponse {
  data: ARRow[];
  count: number;
  message?: string;
}

export const pwg302Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pwg302/query', params);
    return res.data;
  },
  async lookupName(type: 'customer' | 'department', code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(
        `/api/pwg302/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`
      );
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
